import { render, staticRenderFns } from "./AssessmentGenerateRrr.vue?vue&type=template&id=963a818e&scoped=true"
import script from "./AssessmentGenerateRrr.vue?vue&type=script&lang=js"
export * from "./AssessmentGenerateRrr.vue?vue&type=script&lang=js"
import style0 from "./AssessmentGenerateRrr.vue?vue&type=style&index=0&id=963a818e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963a818e",
  null
  
)

export default component.exports